/**
 * Resolves the i18n key for an API error code.
 *
 * The API hands us two kinds of codes: numeric ones (e.g. `3419`, or the numeric
 * string `"3419"`) which live under `apiError.*`, and textual ones (e.g.
 * `"timeout"`) which live under `errors.*`. A code counts as numeric when it
 * contains at least one digit, so numbers wrapped in a string still route to
 * `apiError.*`.
 */
export const getErrorTranslationKey = (code: string | number): string =>
  /\d/.test(String(code)) ? `apiError.${code}` : `errors.${code}`;
